import React from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { styled } from "@mui/material"

import IconArrow from "assets/icons/arrow.svg"
import Image from "components/ui/Image"
import Button from "components/ui/Button"

type Props = React.HTMLAttributes<HTMLButtonElement> & {
  path: string
}

const BackComponent = ({ path, ...restProps }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(path)
  }

  return (
    <Back {...restProps} onClick={handleClick}>
      <Image src={IconArrow} alt={t("common.back")} title={t("common.back")} />
    </Back>
  )
}

export default BackComponent

const Back = styled(Button)`
  background: rgba(172, 172, 172, 0.1);
  border-radius: 50px;
  height: 46px;
  margin: 0;
  padding: 0;
  text-align: center;
  width: 46px;
`
